import { CircleCheck, CircleX, TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { CivilShelterInfo } from "./MapModel";
import { mapShelterDetails } from "./utils/shelterDetailsViewModel";
import { CapacityValue, DetailRow, DetailsList, StatusBadge, Summary, SummaryField } from "./ShelterDetailsStyled";

const ShelterDetails = ({ shelter, address }: { shelter?: CivilShelterInfo; address: string }) => {
  const { t, i18n } = useTranslation();
  const rows = mapShelterDetails(shelter, address, t, i18n.resolvedLanguage || "ro");
  const summary = rows.filter(({ key }) => key === "status" || key === "capacity");
  return (
    <>
      {summary.length > 0 && <Summary $columns={summary.length}>
        {summary.map((row) => {
          const StatusIcon = row.tone === "functional" ? CircleCheck : row.tone === "partial" ? TriangleAlert : CircleX;
          return <SummaryField key={row.key}>
            <dt>{row.label}</dt>
            <dd>{row.key === "status" ? <StatusBadge $tone={row.tone}>
              <StatusIcon size={18} aria-hidden="true" />{row.value}
            </StatusBadge> : <CapacityValue><strong>{row.value}</strong><span>{row.unit}</span></CapacityValue>}</dd>
          </SummaryField>;
        })}
      </Summary>}
      <DetailsList>
        {rows.filter(({ key }) => key !== "status" && key !== "capacity").map((row) => (
          <DetailRow key={row.key} $emphasized={row.key !== "ownership"}>
            <dt>{row.label}</dt><dd>{row.value}</dd>
          </DetailRow>
        ))}
      </DetailsList>
    </>
  );
};

export default ShelterDetails;
